module.exports = __webpack_public_path__ + "media/blue-delete-button.e0401f7f.svg";